import React from 'react';
import ReactDOM from 'react-dom';
import { PropTypes } from '../frameworks/react';
import { MbscScrollViewBase } from './scrollview-base.react';

export class MbscNavigationBase extends MbscScrollViewBase {
    constructor(props) {
        super(props);
    }

    childComponents = []; // Holds child components

    renderChildren = () => {
        return React.Children.map(this.props.children, (child) => {
            // need to clone child elements, to pass extra props
            // need to pass ref prop, to get access to the component
            return React.cloneElement(child, {
                ref: (childComp) => {
                    this.childComponents.push(childComp);
                }
            });
        });
    }
}

var guid = +new Date();

export class MbscNavItemBase extends React.Component {
    constructor(props) {
        super(props);
        this._instance = null;
        this._DOMNode = null;
        this.id = props.id || guid++;
    }

    static propTypes = {
        selected: PropTypes.bool,
        disabled: PropTypes.bool,
        icon: PropTypes.string,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }

    setInstance = (inst) => {
        this._instance = inst;
    }

    componentDidMount = () => {
        this._DOMNode = ReactDOM.findDOMNode(this);
    }
}




// WEBPACK FOOTER //
// ./src/js/lib/mobiscroll/classes/navigation-base.react.jsx